import lodash from "lodash";
import { conditionFormChecker, copyForm, putField } from "../../../../../utils/form";
import {
    createField as createCommonField
} from "../license/request-license.section";
import {
    createFieldSelect, createFieldTemplateBuilder
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { Modal } from "ant-design-vue";
import {
    callSearchLicense,
    callSearchLicenseFull
} from "../license/request-license.section";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import router from "../../../../../router";
import {
    setKeepDataInputFromUserFillForm,
    setNullAfterSelectLicenseForRequest, setRequesterAddressFromCurrentUserAddress,
    setRequesterAddressFromLicense,
    setRequesterDetailFromCurrentUserInfo,
    setRequesterDetailFromLicenseOwnerDetail
} from "../license/request-license.logic";

export const createField = ({ props, data, key, isLoading }) => {
    // const { viewOnly, menuContext } = props;
    // const { useForm } = data;
    // const { modelRef } = useForm;
    // const model = key ? lodash.get(modelRef, key) : modelRef;
    // const prefix = key ? `${key}.` : "";

    return putField({
        data,
        fields: [
            ...createFieldRenewDetail({ props, data, key }),
            ...createCommonField({ props, data, key, isLoading }),
        ]
    });
}

export const createFieldRenewDetail = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const userInfo = store.state.resource.auth.info?.user;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}renewDetailSection`,
                cardBorderProp: () => ({
                    bodyStyle: { paddingLeft: '0px' },
                    title: i18n.global.t("views.request.licenseRequest.requestPurpose.renewRequest"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24, class: "mt-4" }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refOriginal`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.licenseRequest.refOriginal"),
                            inputProp: ({ field }) => {
                                return lodash.merge(
                                    {
                                        value: model.refOriginal,
                                        "onUpdate:value": (value) => {
                                            const oldValue = model.refOriginal;
                                            model.refOriginal = value;
                                            if (oldValue) {
                                                Modal.confirm({
                                                    title: i18n.global.t("views.request.modal.change", {
                                                        text: i18n.global.t("views.request.licenseRequest.modal.confirmChangeLicense"),
                                                    }),
                                                    autoFocusButton: "cancel",
                                                    onOk: () => {
                                                        callRequestLicenseById({ model, id: value?.id, data });
                                                    },
                                                    onCancel: () => {
                                                        model.refOriginal = oldValue;
                                                    },
                                                });
                                            } else {
                                                callRequestLicenseById({ model, id: value?.id, data });
                                            }
                                        },
                                        disabled: viewOnly,
                                        list: ({ searchQuery }) => callSearchLicense({
                                            searchQuery,
                                            userInfo,
                                            refLicenseStatusKey: "active",
                                            props,
                                            moreWhere: [{ name: "isCanRenew", type: "Boolean", operator: "=", value: true },],
                                            data
                                        }),
                                        optLabel: "licenseCode",
                                        allowClear: false,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                );
                            },
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                    ]}),
                }),
            }),
        ]
    })
}


export const callRequestLicenseById = ({ model, id }) => {
    setIsLoadingApp(true);
    if (id) {
        callSearchLicenseFull({ id }).then((requestLicense) => {
            const refRequestLicenseTemp = copyForm({ form: {
                ...requestLicense,
                refOriginal: requestLicense,
                licenseIssueDate: null,
                licenseExpiredDate: null,
            } });
            setIsLoadingApp(false);
            if (id) {
                setNullAfterSelectLicenseForRequest({ refRequestLicenseTemp })
                /* model = ที่กรอกไปแล้วก่อนเลือกใบอนุญาต + ที่โหลด Default Value ที่ถูก Set มาจาก Load Default Form */
                setKeepDataInputFromUserFillForm({ refRequestLicenseTemp, keyIn: model  })
                if (model.isOfficerCreate) {
                    setRequesterDetailFromLicenseOwnerDetail({ refRequestLicenseTemp, requestLicense })
                    setRequesterAddressFromLicense({ refRequestLicenseTemp, requestLicense })
                } else {
                    setRequesterDetailFromCurrentUserInfo({ refRequestLicenseTemp })
                    setRequesterAddressFromCurrentUserAddress({ refRequestLicenseTemp })
                }
                const refVesselRequestTemp = copyForm({
                    form: { ...requestLicense.refVesselRequest,
                    attachmentVesselIdentities: [{ group: "VesselIdentity" }],
                    attachmentPositionVesselIdentities: [{ group: "PositionVesselIdentity" }],
                    attachmentHeadVessels: [{  group: "HeadVessel" }],
                    attachmentFullVessels: [{ group: "FullVessel" }],
                }});
                refVesselRequestTemp.refOriginal = requestLicense.refVesselRequest;
                refVesselRequestTemp.vesselOwnerRequests?.forEach(
                    (d, index) => (d.refOriginal = { id: requestLicense.refVesselRequest.vesselOwnerRequests[index].id })
                );
                refRequestLicenseTemp.fishingToolRequests?.forEach(
                    (d, index) => (d.refOriginal = { id: requestLicense.fishingToolRequests[index].id })
                );
                refRequestLicenseTemp.refVesselRequest = refVesselRequestTemp;

            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: refRequestLicenseTemp }) },
                query: { _timestamp: new Date().getTime() },
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() },
        });
    }
};

